// Footer translations - English
export const footerEn = {
  titles: {
    links: 'Quick Links',
    contact: 'Contact',
  },
  links: {
    vehicles: 'Vehicles',
    about: 'About Us',
    contact: 'Contact',
  },
  rights: 'All rights reserved.',
};

